import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, Title } from '@angular/platform-browser';
import { CdkTreeModule } from '@angular/cdk/tree';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NgModule } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';

/* NGXS */
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';

/* Modules */
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from '@modules/auth/auth.module';
import { LayoutModule } from '@modules/layout/layout.module';

/* Components */
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

/* State and Services */
import { AppState } from '@core/store/app/app.state';
import { AuthState } from '@core/store/auth/auth.state';

/* Interceptors */
import { AuthInterceptor } from '@core/interceptors/auth.interceptor';

@NgModule({
	declarations: [AppComponent],
	imports: [
		NgxsModule.forRoot([AuthState, AppState], {
			developmentMode: !environment.production,
			selectorOptions: { injectContainerState: false, suppressErrors: false },
		}),
		NgxsLoggerPluginModule.forRoot({ collapsed: true }),
		NgxsStoragePluginModule.forRoot({ key: ['auth.token'] }),
		NgxsRouterPluginModule.forRoot(),
		BrowserModule,
		BrowserAnimationsModule,
		LayoutModule,
		AuthModule,
		AppRoutingModule,
		CdkTreeModule,
		HttpClientModule,
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: environment.production,
			// Register the ServiceWorker as soon as the app is stable
			// or after 30 seconds (whichever comes first).
			registrationStrategy: 'registerWhenStable:30000',
		}),
	],
	providers: [
		Title,
		{ provide: MAT_DATE_LOCALE, useValue: 'sv-SE' },
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
